import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { getCurrentTenant, getIsConnectionStarted, getLoggedInUserId } from 'src/app/state';
import * as DataImportLogActions from '../state/actions/data-import-logs.actions';
import { TranslationLoaderFacade } from '../../../localization/translation-loader.facade';
import { DataImportLogData } from '../state/data-import-logs.reducer';
import { State, getDataImportLogStateData } from '../state/index';

@Component({
  selector: 'app-data-import-logs',
  templateUrl: './data-import-logs.component.html',
  styleUrls: ['./data-import-logs.component.scss']
})

export class DataImportLogsComponent implements OnInit, OnDestroy {

  tenantId?: number;
  userId?: number;

  logData$?: Observable<DataImportLogData[]>;
  dataImportSubscriptions = new Subscription();

  constructor(private store: Store<State>, private translationLoaderFacade: TranslationLoaderFacade) { }

  ngOnInit() {

    this.store.select(getCurrentTenant).subscribe(tenant => this.tenantId = tenant.tenantID);
    this.store.select(getLoggedInUserId).subscribe(userId => this.userId = userId);

    const signalRConnectionSubscription = this.store.select(getIsConnectionStarted).subscribe(
      isHubConnected => {
        if (isHubConnected) {
          console.log("Data Import connected to message hub");
          if (this.userId && this.tenantId) {
            this.store.dispatch(DataImportLogActions.subscribeToProvisionLogData({
              tenantId: this.tenantId,
              userId: this.userId
            }));
          }
        }
      }
    )

    this.dataImportSubscriptions.add(signalRConnectionSubscription);
    this.logData$ = this.store.select(getDataImportLogStateData);
    this.logData$.subscribe(() => {

    });
  }

  clearLogs(): void {
    this.store.dispatch(DataImportLogActions.clearProvisionLogData({ state: [] }));
  }

  ngOnDestroy(): void {
    this.dataImportSubscriptions.unsubscribe();
  }

  logClass(log: DataImportLogData) {
    return log.logType == 'Success' ? 'success' :
      log.logType == 'Warning' ? 'warning' :
        log.logType == 'Info' ? 'info' :
          log.logType == 'Error' ? 'error' :
            'default';
  }
}
